import React, { useEffect, useState } from 'react'
import BusinessAdminRegistration from './BusinessAdminRegistration'
import BusinessRegistration from './BusinessRegistration'
import Navbar from './Navbar'
import "./BusinessRegistration.css"

const BusinessAllRegistration = () => {
  const [activeForm, setActiveForm] = useState("single"); // "single" nebo "multi"
   
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0)
    }
    scrollToTop()
  }, [])
  return (
    <div>
      <Navbar />

      <div className="registration-button-group">
        <button
          className={activeForm === "single" ? "active" : ""}
          onClick={() => setActiveForm("single")}
        >
          Registrace podniku samostatně
        </button>
        <button
          className={activeForm === "multi" ? "active" : ""}
          onClick={() => setActiveForm("multi")}
        >
          Registrace podniku s více profily
        </button>
      </div>

      <div className="businesess-registarion-conteiner">
        {activeForm === "single" && (
          <div>
            <BusinessRegistration />
          </div>
        )}
        {activeForm === "multi" && (
          <div>
            <BusinessAdminRegistration />
          </div>
        )}
      </div>
    </div>
  )
}

export default BusinessAllRegistration;